import React, { useEffect } from "react";
import gsap from "gsap";

function Banner() {
  useEffect(() => {
    let interiorDesignHeading = gsap.timeline({
      defaults: { ease: "Power3.easeInOut", duration: 1 },
    });
    interiorDesignHeading.to(".service-heading", {
      clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)",
      opacity: 1,
      x: 0,
      duration: 1.2,
    });
    let interiorDesignDescription = gsap.timeline({
      defaults: { ease: "Power3.easeInOut", duration: 1 },
    });
    interiorDesignDescription.to(".service-description-trigger", {
      clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)",
      opacity: 1,
      x: 0,
      duration: 1.2,
    });
  });
  return (
    <section className="section-padding-normal interior-design-bg interior-trigger-item align-row-banner">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="flex-center">
              <p className="service-description service-description-trigger">
                We offer the best
              </p>
            </div>
            <h1 className="service-heading">
              Interior Design, <br />
              at it's best.
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
